# F88 — Asset Instance create screen
# Route: /asset/instances/new
# POST /api/asset/instances (CreateAssetInstanceRequest: Name, AssetClassRef,
# SerialNumber, Location{Level1,Level2,Level3}). Same write path the AI
# instance-authoring tool set (FR-4) calls — one form, one command.

page-config-asset-instance-create:
  type: Page
  archetype: create
  meta:
    title: $t.config_asset_instance.create_title
    route: /asset/instances/new
    layout: shell
    auth: required
  data:
    classes:
      model: AssetClassOption[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - config-ai-create-sm-notice
    - config-ai-create-content

config-ai-create-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_desktop

config-ai-create-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - config-ai-create-header
    - config-ai-create-form

config-ai-create-header:
  type: PageHeader
  content: $t.config_asset_instance.create_title
  back_route: /asset/instances

config-ai-create-form:
  type: Form
  model: CreateAssetInstanceForm
  mode: create
  a11y:
    label: $t.config_asset_instance.create_form_label
  action:
    type: create
    model: AssetInstance
    on_success: navigate(/asset/instances)
  spatial:
    display: flex
    direction: column
    gap: $spacing.md
  children:
    - config-ai-create-field-name
    - config-ai-create-field-class
    - config-ai-create-field-serial
    - config-ai-create-field-location
    - config-ai-create-form-actions

config-ai-create-field-name:
  type: Input
  input_type: text
  bind:
    value: name
  label: $t.config_asset_instance.field_name
  required: true
  a11y:
    label: $t.config_asset_instance.field_name

config-ai-create-field-class:
  type: Input
  input_type: select
  bind:
    value: assetClassRef
    options: classes
  label: $t.config_asset_instance.field_class
  required: true
  a11y:
    label: $t.config_asset_instance.field_class

config-ai-create-field-serial:
  type: Input
  input_type: text
  bind:
    value: serialNumber
  label: $t.config_asset_instance.field_serial
  required: true
  a11y:
    label: $t.config_asset_instance.field_serial

# Placement (FR-5, DESIGN §D5) — M1 placement is ONE free-text field (maps to
# location.level1; deeper levels stay API/AI-only until the M2 entity-linked
# picker).
config-ai-create-field-location:
  type: Input
  input_type: text
  bind:
    value: location.level1
  label: $t.config_asset_instance.field_location
  helper: $t.config_asset_instance.field_location_helper
  required: true
  a11y:
    label: $t.config_asset_instance.field_location

config-ai-create-form-actions:
  type: FormActions
  submit_label: $t.config_asset_instance.btn_create
  cancel_route: /asset/instances
